module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "announcement"
  }, [_c('div', {
    staticClass: "top-wrapper"
  }, [_c('div', {
    staticClass: "title-wrapper"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('word.announcement')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('word.total')) + " " + _vm._s(_vm.totalCount) + " " + _vm._s(_vm.$t('word.item')))])])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.pageLoading),
      expression: "pageLoading",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "announcement-list"
  }, _vm._l((_vm.announcementList), function(announcement) {
    return _c('div', {
      staticClass: "announcement"
    }, [_c('div', {
      staticClass: "announcement-title-wrapper"
    }, [_c('span', {
      staticClass: "title",
      class: {
        'active': _vm.isValid(announcement.invalidTime)
      }
    }, [_vm._v(_vm._s(announcement.title))]), _vm._v(" "), _c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm.formatDate(announcement.createTime)) + " ~ " + _vm._s(_vm.formatDate(announcement.invalidTime)))])]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(announcement.content) + "\n                ")])])
  }))]), _vm._v(" "), (_vm.totalPage >= 2) ? _c('div', {
    staticClass: "center-tasks-pagination"
  }, [_c('el-pagination', {
    attrs: {
      "page-count": _vm.totalPage,
      "layout": "prev, pager, next"
    },
    on: {
      "current-change": _vm.getAnnouncementList
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e93743a4!./~/vue-loader/lib/selector.js?type=template&index=0!./views/components/Announcement.vue
// module id = 1099
// module chunks = 0